import type { RouteRecordRaw } from 'vue-router'

export const schedulesRoutes: RouteRecordRaw[] = [
  {
    path: '/schedules/:schedule_id',
    meta: {
      layout: 'dash',
      protected: true,
    },
    children: [
      {
        path: ':sked_tab(programs)',
        name: 'schedules.programs',
        component: () => import('@/pages/schedules/Program'),
      },
      {
        path: ':sked_tab(work-time)',
        name: 'schedules.work_time',
        component: () => import('@/pages/schedules/WorkTime'),
      },
    ],
  },
  {
    path: '/schedules/:catchAll(.*)',
    name: 'objects.not_type',
    component: () => import('@/pages/object/NotType'),
  },
]
